var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NOGO",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-213 -39)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    fill: "#ff7600",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(213 39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1647",
    "data-name": "Rechteck 1647",
    fill: "#fff",
    width: 10,
    height: 2,
    transform: "translate(216 46)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNogo);
export default __webpack_public_path__ + "static/media/nogo.bfbc52f9aec0c39e5aed4042726fc9c2.svg";
export { ForwardRef as ReactComponent };